import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Notifcations } from 'src/app/_models/request-model';
import { RequestService } from 'src/app/_services/request.service';

@Component({
  selector: 'app-view-notifications',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-notifications.component.html',
  styleUrl: './view-notifications.component.css'
})

export class ViewNotificationsComponent {

  notificationsList: Array<Notifcations> = [];

  constructor(public modalRef: BsModalRef,
    private requestService: RequestService,
    private router: Router) {
      this.getNotificationsList();
  }

  getNotificationsList() {
    this.requestService.getNotificationsData().subscribe({
      next: (resp: Array<Notifcations>) => {
        if (resp.length > 0) {
          this.notificationsList = resp;
        }
        else {
          this.notificationsList = [];
        }
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }

  navigateToRequests(res: Notifcations) {
    // skipLocationChange: true
    this.router.navigate(['/my-requests'], { queryParams: { Pid: res.Request_Id } });
    this.close();
  }

  close() {
    this.modalRef.hide();
  }

}
